import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FilePreviewModel,
  UploaderCaptions,
  ValidationError,
} from 'ngx-awesome-uploader';
import { ToastrService } from 'ngx-toastr';
import { Observable, of, delay } from 'rxjs';
import { Helps } from 'src/app/libs/helps';
import { Images } from 'src/app/models/interfaces/images';
import { ApiService } from 'src/app/services/api.service';
import { ImagePickerService } from 'src/app/services/image-picker.service';

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.css'],
})
export class UploadImageComponent implements OnInit {
  constructor(private http: HttpClient, private toast: ToastrService, private api: ApiService, private helps: Helps) { }


  @Output()
  onSuccess = new EventEmitter<boolean>(false);
  domain: string = this.api.domain;
  @Output()
  onResult = new EventEmitter<Images>();
  @Output()
  onRemove = new EventEmitter<Images>();
  public myFiles: FilePreviewModel[] = [];
  adapter = new ImagePickerService(this.http, this.api, this.helps);
  public captions: UploaderCaptions = {
    dropzone: {
      title: 'Arrastre y suelte aquí',
      or: 'ó',
      browse: 'Subir imagen desde directorio',
    },
    cropper: {
      crop: 'cortar',
      cancel: 'cancelar',
    },
    previewCard: {
      remove: 'Si',
      uploadError: 'Ocurrio un error al subir la imagen',
    },
  };

  ngOnInit(): void { }
  public onValidationError(error: ValidationError): void {
    console.log("Error");
    this.toast.warning(`La imagen «${error.file.name}» no es válida (${error.error}).`, 'IMAGEN');
  }

  public onUploadSuccess(e: FilePreviewModel): void {
    console.log("success image");
    console.log(e);
    var item: Images;
    if (e?.uploadResponse?.data?.status=="ok") {
      item = e?.uploadResponse?.data as Images;
      var link = this.domain + 'img/upload/' + item.path  + item.name;
      item.link = link;

      this.onResult.emit(item);
      this.onSuccess.emit(true);
    }

  }
  onUploadFail(e: any) {
    console.log("fail image");
    console.log(e);
    this.toast.warning(e.error.mistakes, "Error al subir imagen");
  }
  public onRemoveSuccess(file: FilePreviewModel) {
    console.log("RemoveSuccess");
    console.log(file);
    var item: Images;
    if(file?.uploadResponse?.data!=null){
      item = file?.uploadResponse?.data as Images; 
      this.onRemove.emit(item);
    this.onSuccess.emit(true);
    }
   
  }
  public onFileAdded(file: FilePreviewModel) {
    console.log(" onFileAdded");
    this.myFiles.push(file);
  }

  public myCustomValidator(file: File): Observable<boolean> {
    if (!file.name.includes('uploader')) {
      return of(true).pipe(delay(2000));
    }

    return of(false).pipe(delay(2000));
  }

}
